/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2020 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { addToEndOfChain, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { chain as AddToCartChain } from "@insite/client-framework/Store/Pages/Cart/Handlers/AddToCart";
import { chain as RemoveCartLineChain } from "@insite/client-framework/Store/Pages/Cart/Handlers/RemoveCartLine";
import {
    chain as PlaceOrderChain,
    SendTracking,
} from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/PlaceOrder";
import { chain as UpdateCartChain } from "@insite/client-framework/Store/Pages/CheckoutShipping/Handlers/UpdateCart";

function getDataLayer() {
    return (window as any).dataLayer;
}

export const _GaAddProductToCart: any = (props: any) => {
    const dataLayer = getDataLayer();
    if (!dataLayer) {
        return;
    }

    const data = {
        event: "addToCart",
        ecommerce: {
            currencyCode: "USD",
            add: {
                products: [
                    {
                        name: props.apiResult.shortDescription,
                        id: props.apiResult.erpNumber,
                        price: props.apiResult.pricing.unitNetPrice,
                        brand: props.apiResult.brand?.name || "",
                        category: props.apiResult.properties["category"],
                        quantity: props.apiResult.qtyOrdered,
                    },
                ],
            },
        },
    };

    dataLayer.push(data);
};

export const _GaRemoveCartLine: any = (props: any) => {
    const dataLayer = getDataLayer();
    if (!dataLayer) {
        return;
    }

    const cart = getCurrentCartState(props.getState()).value;
    const cartLine = cart?.cartLines?.find(c => c.id === props.apiParameter.cartLineId) as any;
    if (cartLine) {
        const data = {
            event: "removeFromCart",
            ecommerce: {
                currencyCode: "USD",
                add: {
                    products: [
                        {
                            name: cartLine.shortDescription,
                            id: cartLine.erpNumber,
                            price: cartLine.pricing.unitNetPrice,
                            brand: cartLine.brand?.name || "",
                            category: cartLine.properties["category"],
                            quantity: cartLine.qtyOrdered,
                        },
                    ],
                },
            },
        };

        dataLayer.push(data);
    }
};

export const _GaPlaceOrder: any = (props: any) => {
    const dataLayer = getDataLayer();
    if (!dataLayer) {
        return;
    }

    const session = getSession(props.getState());
    const { apiResult } = props;

    const data = {
        event: "purchase",
        ecommerce: {
            purchase: {
                actionField: {
                    id: apiResult.cart.orderNumber,
                    affiliation: apiResult.billTo.companyName,
                    revenue: apiResult.cart.orderGrandTotal,
                    tax: apiResult.cart.totalTax,
                    shipping: apiResult.cart.shippingAndHandling,
                    currencyCode: session.currency?.currencyCode,
                },
                products: <any>[],
            },
        },
    };

    // eslint-disable-next-line array-callback-return
    props.cartToUpdate.cartLines.map((cartLine: any) => {
        data.ecommerce.purchase.products.push({
            name: cartLine.shortDescription,
            id: cartLine.erpNumber,
            price: cartLine.pricing.unitNetPrice,
            brand: cartLine.brand?.name || "",
            category: cartLine.properties["category"],
            quantity: cartLine.qtyOrdered,
        });
    });

    dataLayer.push(data);
};

addToEndOfChain(AddToCartChain, _GaAddProductToCart);
addToEndOfChain(RemoveCartLineChain, _GaRemoveCartLine);
replaceInChain(PlaceOrderChain, SendTracking, _GaPlaceOrder);

/* eslint-disable */
(function(window) {

    (window as any)._GaCheckoutFunnel = (cart: any,step: any) => {
        const dataLayer = getDataLayer();
        if (!dataLayer) {
            return;
        }
    
    
        const data: any = {
            event: "checkout",
            ecommerce: {
                checkout: {
                    actionField: { step },
                    products: [],
                },
            },
        };
    
        cart?.cartLines?.map((cartLine: any) => {
            data.ecommerce.checkout.products.push({
                name: cartLine.shortDescription,
                id: cartLine.erpNumber,
                price: cartLine?.pricing?.unitNetPrice || 0,
                brand: cartLine.brand?.name || "",
                category: cartLine.properties["category"],
                quantity: cartLine.qtyOrdered,
            });
        });
    
        dataLayer.push(data);
    };
    
})(typeof window != 'undefined' ? window : {})
/* eslint-enable */
